import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.Accounting}`;

export async function getAccountingTransactions(data) {
  return await Client.get(`${endpoint}/transactions`, data, true);
}

// 거래명세서 > 거래명세서 카테고리
export async function getAccountingTransactionsCategory() {
  return await Client.get(`${endpoint}/transactions/category`, {}, true);
}

export async function transactionsExcelExport(data, fileName) {
  return await Client.downLoadFile(`${endpoint}/transactions/excel`, data, true, fileName);
}

export async function transactionsExcelDeliveryConfirmExport(data, fileName) {
  return await Client.downLoadFile(`${endpoint}/transactions/excelDeliveryConfirm`, data, true, fileName);
}
